import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { InfoTip } from "./InfoTip";

export const Section = ({ title, subtitle, info, testId, children, action }) => (
  <Card className="border-slate-200 shadow-sm" data-testid={testId}>
    <CardHeader className="pb-2">
      <div className="flex items-start justify-between gap-3">
        <div>
          <CardTitle className="text-base font-semibold text-slate-900 flex items-center gap-2">
            {title}
            {info && <InfoTip text={info} testId={`${testId}-info`} />}
          </CardTitle>
          {subtitle && <p className="text-xs text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {action}
      </div>
    </CardHeader>
    <CardContent>{children}</CardContent>
  </Card>
);

export const EmptyState = ({ message, testId }) => (
  <div className="flex items-center justify-center h-32 text-sm text-slate-400 text-center px-4" data-testid={testId}>
    {message}
  </div>
);

export const MiniStat = ({ label, value, hint, testId }) => (
  <div className="p-3 rounded-lg border border-slate-200 bg-slate-50/60" data-testid={testId}>
    <p className="text-[11px] uppercase tracking-wide text-slate-500 font-medium">{label}</p>
    <p className="text-xl font-bold text-slate-900 mt-1">{value}</p>
    {hint && <p className="text-xs text-slate-500 mt-0.5">{hint}</p>}
  </div>
);

export const chartTooltip = { backgroundColor: "#fff", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: 12 };
